import { Link } from '../router.js'
import { avertissementNuit, depuisDerniereLecture, enteteNuit, libelleLigne, type VueNuit } from './nuit-billetteries-model.js'

/**
 * LA NUIT EN UNE LIGNE — « 636 entrées cette nuit : L'ÉTUDIANTE 421
 * (Shotgun) · MEDECINE 215 (Pretix) ».
 *
 * Même rendu partout (carte du direct, tableau de bord, cockpit) : le total en
 * tête, puis une pastille par ligne, la billetterie en petit. Les lignes ne
 * sont des liens que hors d'une carte déjà cliquable (`liens`) : un lien dans
 * un lien n'est ni valide ni prévisible au clic.
 */
export function NuitBilletteries({ nuit, liens = false, sansTete = false }: { nuit: VueNuit; liens?: boolean; sansTete?: boolean }) {
  // Une billetterie qui n'est plus lue : son nombre est figé, le total aussi.
  // Dit ici, sous le total — même quand la tête est portée par le grand
  // nombre de la carte (`sansTete`), dont la fraîcheur affichée est celle
  // d'une AUTRE billetterie.
  const avertissement = avertissementNuit(nuit)
  return (
    <div className="so-nuit" role="group" aria-label={nuit.phrase}>
      {sansTete ? null : <p className="so-nuit__tete">{enteteNuit(nuit)}</p>}
      {avertissement ? <p className="so-nuit__perime" role="status">{avertissement}</p> : null}
      <ul className="so-nuit__lignes">
        {nuit.lignes.map((l) => {
          const contenu = (
            <>
              <span className="so-nuit__nom">{libelleLigne(l)}</span>
              <strong className="so-nuit__n">{l.scanned.toLocaleString('fr-FR')}</strong>
              <span className="so-nuit__billetterie">{l.billetterie}</span>
              {l.perime ? <span className="so-nuit__fige" title={depuisDerniereLecture(l.derniere_lecture)}>figé</span> : null}
            </>
          )
          const cible = l.soirees[0]?.id
          return (
            <li key={l.cle} className={`so-nuit__ligne${l.associations ? ' so-nuit__ligne--asso' : ''}${l.perime ? ' so-nuit__ligne--fige' : ''}`}
              // La bulle dit d'où viennent les entrées : le libellé réglé pour
              // les associations, et le détail d'un groupe.
              title={[l.associations ? nuit.libelle_associations : null, l.nombre > 1 ? l.soirees.map((s) => s.name).join(' · ') : null]
                .filter(Boolean).join(' — ') || undefined}>
              {liens && cible ? <Link href={`/soirees/${cible}`} className="so-nuit__lien">{contenu}</Link> : contenu}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
